var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelpCircle = function SvgHelpCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25.289062 12.507812 C 21.559062 12.507813 19.085875 14.767938 18.546875 18.210938 C 18.511875 18.426937 18.617984 18.569469 18.833984 18.605469 L 21.09375 19.001953 C 21.30975 19.037953 21.452281 18.929844 21.488281 18.714844 C 21.918281 16.526844 23.208797 15.306641 25.216797 15.306641 C 27.261797 15.306641 28.695312 16.598578 28.695312 18.642578 C 28.695313 19.862578 28.265719 20.687203 27.011719 22.408203 L 24.607422 25.707031 C 23.854422 26.748031 23.533203 27.5015 23.533203 28.9375 L 23.533203 30.40625 C 23.533203 30.62125 23.675625 30.765719 23.890625 30.761719 L 26.257812 30.761719 C 26.472813 30.761719 26.615234 30.619297 26.615234 30.404297 L 26.615234 29.257812 C 26.615234 28.038812 26.831828 27.536359 27.548828 26.568359 L 29.951172 23.267578 C 31.171172 21.581578 31.779297 20.327469 31.779297 18.605469 C 31.779297 15.054469 29.161062 12.507812 25.289062 12.507812 z M 23.712891 33.492188 C 23.496891 33.492187 23.353516 33.636562 23.353516 33.851562 L 23.353516 36.935547 C 23.353516 37.150547 23.495891 37.292969 23.712891 37.292969 L 26.439453 37.292969 C 26.653453 37.292969 26.796875 37.151547 26.796875 36.935547 L 26.796875 33.851562 C 26.796875 33.637563 26.654453 33.492188 26.439453 33.492188 L 23.712891 33.492188 z",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-circle.6fa91f2b.svg";
export { ForwardRef as ReactComponent };